<template>
  <div id="settingsMenu">
    <acv-legacy-dropdown
      ref="settingsMenu"
      align="right"
    >
      <template #trigger="{ toggle }">
        <button
          type="button"
          class="settings-menu-toggle"
          @click="toggle"
        >
          <span class="tw-sr-only">
            Settings Menu
          </span>
          <slot name="button-content">
            <GearSVG />
          </slot>
        </button>
      </template>
      <slot name="menu-content">
        <router-link
          class="dropdown-item"
          to="/settings/account"
          @click="trackMenuItemSelected('Settings')"
        >
          Settings
        </router-link>
        <router-link
          class="dropdown-item"
          to="/logout"
          @click="handleLogout"
        >
          Logout
        </router-link>
      </slot>
    </acv-legacy-dropdown>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import AcvLegacyDropdown from '@/components/Inputs/AcvLegacyDropdown.vue';
import GearSVG from '@/assets/svg/gear.svg';
import Analytics from '@/mixins/Analytics';

export default defineComponent({
  name: 'AcvSettingsDropdownMenu',
  components: {
    AcvLegacyDropdown,
    GearSVG,
  },
  mixins: [
    Analytics,
  ],
  methods: {
    show() {
      this.$refs.settingsMenu.show();
    },
    hide() {
      this.$refs.settingsMenu.hide();
    },
    handleLogout() {
      // clear stored route
      this.$store.dispatch('clearGoToAfterLogin');
      this.trackMenuItemSelected('Logout');
    },
    trackMenuItemSelected(item) {
      this.track(this.eventNames.userMenuSelected, {
        item_selected: item,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
#settingsMenu {
  .settings-menu-toggle {
    padding: 0;
    background: none;
    border: 0;
    line-height: 1;
    top: -1px;

    &:hover {
      background: constants.$darker-gray;

      svg {
        color: rgb(255 255 255 / 100%);
      }
    }

    &:focus,
    &:active {
      outline: 0;
      border: 0;
      box-shadow: none;
    }
  }

  ::v-deep .acv-legacy-dropdown__panel {
    padding: 0;
    margin: 20px 0 0;
    border: 0;
    border-radius: 2px;
    min-width: auto;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
    background: white;
  }

  ::v-deep .dropdown-item {
    display: block;
    padding: 14px 15px;
    text-align: right;
    font-size: 14px;
    line-height: 1rem;
    margin-right: 30px;
    outline: none;
    border-bottom: solid 1px rgb(50 50 50 / 10%);
    font-weight: 500;
    letter-spacing: 1.25px;
    color: rgb(0 0 0 / 50%);

    &:hover {
      background: #f3f3f3;
    }

    &:last-of-type {
      border: none;
    }
  }

  svg {
    color: rgb(255 255 255 / 80%);
    font-size: 21.44px;

    &:hover {
      i,
      svg {
        color: rgb(255 255 255 / 100%);
      }
    }
  }
}
</style>
